export class ConversionConfiguration {
    public conversionId?:number;
    public description?:string;
    public intervalId?:number;
    public noCreditsFrom?:number;
    public noCreditsTo?:number;
    public createUserId?:number;
    public modifUserId?:number;    
    public activeId?:boolean;    
}

